import { useState, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";
import React from "react";
import Draggable from "react-draggable";

export const DateModal = ({
  id,
  deleteData,
  componentInfo,
  patchSettingsToBackend2,
  dateData,
  componentName
}) => {

  const [settings, setSettings] = useState({});
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [isDraggable, setIsDraggable] = useState(true);
  const [timeouts, setTimeouts] = useState({
    slidingText: null,
    textSize: null,
    animationDuration: null,
    height: null,
    width: null,
    xPosition: null,
    yPosition: null,
    opacity: null,
    info: null,
    zIndex: null,
  });
  const nodeRef = useRef(null);
  useEffect(() => {
    if (componentInfo) {
      setSettings({
        backgroundColor: componentInfo.color,
        textColor: componentInfo.textColor,
        opacity: componentInfo.opacity,
        width: componentInfo.width,
        height: componentInfo.height,
        textSize: componentInfo.textSize,
        xPosition: componentInfo.xPosition,
        yPosition: componentInfo.yPosition,
        dateFormat: componentInfo.dateFormat,
        zIndex: componentInfo.zIndex,
      });
    }
  }, [componentInfo]);

  const updateTimeout = (key, value) => {
    setTimeouts((prevTimeouts) => ({
      ...prevTimeouts,
      [key]: value,
    }));
  };

  useEffect(() => {
    return () => {
      Object.values(timeouts).forEach((timeout) => clearTimeout(timeout));
    };
  }, [timeouts]);

  const handleOnBackgroundChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, backgroundColor: newColor });
    patchSettingsToBackend2(
      {
        color: newColor,
      },
      dateData.SettingsJson,
      id
    );
  };

  const handleOnTextColorChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, textColor: newColor });
    patchSettingsToBackend2(
      {
        textColor: newColor,
      },
      dateData.SettingsJson,
      id
    );
  };

  const handleSettingChange = (key, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [key]: value,
    }));
    clearTimeout(timeouts[key]);
    updateTimeout(
      key,
      setTimeout(() => {
        patchSettingsToBackend2({ [key]: value }, dateData.SettingsJson, id);
      }, 500)
    );
  };

  const handleDateFormatChange = (e) => {
    const newFormat = e.target.value;
    handleSettingChange("dateFormat", newFormat);
  };

  const handleInputChange = (key, value, maxLimit) => {
    let parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      parsedValue = 2;
    } else if (parsedValue > maxLimit) {
      parsedValue = maxLimit;
    }
    handleSettingChange(key, parsedValue);
  };

  return (
    <Draggable nodeRef={nodeRef} disabled={!isDraggable}>
      <div
        className="modal"
        id={`dateModal${id}`}
        tabIndex="-1"
        aria-labelledby={`dateModal${id}`}
        aria-hidden="true"
        data-bs-backdrop="static"
        ref={nodeRef}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h4 className="modal-title fs-5" id={`dateModal${id}`}>
                Properties for {componentName}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body"
              onMouseEnter={() => setIsDraggable(false)}
              onMouseLeave={() => setIsDraggable(true)}
            >
              <>
                <ol className="list-group list-group-flush text-start">
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className=" me-auto">Opacity</div>
                    <span className="me-2">{settings.opacity}%</span>
                    <span>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="100"
                        step="25"
                        id="dateRange3"
                        value={settings.opacity || 0}
                        onChange={(e) =>
                          handleSettingChange(
                            "opacity",
                            parseInt(e.target.value)
                          )
                        }
                      />
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span
                          className="input-group-text border-end-0"
                          id="widthDate"
                        >
                          width
                        </span>
                        <input
                          name="width"
                          type="number"
                          max={24 - settings.xPosition || 0}
                          className="form-control"
                          aria-label="width"
                          aria-describedby="width"
                          onChange={(e) =>
                            handleInputChange(
                              "width",
                              e.target.value,
                              24 - settings.xPosition
                            )
                          }
                          value={settings.width || ""}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text" id="heightDate">
                          height
                        </span>
                        <input
                          name="height"
                          type="number"
                          min={2}
                          className="form-control"
                          max={24 - settings.yPosition || 0} 
                          aria-label="height"
                          aria-describedby="height"
                          onChange={(e) =>
                            handleInputChange(
                              "height",
                              e.target.value,
                              24 - settings.yPosition
                            )
                          }
                          value={settings.height || ""}
                        />
                      </div>
                    </div>
                  </li>

                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span className="input-group-text" id="X">
                          X
                        </span>
                        <input
                          name="X"
                          min={0}
                          max={24 - settings.width || 0}
                          type="number"
                          className="form-control"
                          aria-label="X"
                          aria-describedby="X"
                          onChange={(e) =>
                            handleInputChange(
                              "xPosition",
                              e.target.value,
                              24 - settings.width
                            )
                          }
                          value={settings.xPosition || 0}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text border-end-0" id="Y">
                          Y
                        </span>
                        <input
                          name="Y"
                          type="number"
                          className="form-control"
                          aria-label="Y"
                          min={0}
                          max={24 - settings.height || 0}
                          aria-describedby="Y"
                          onChange={(e) =>
                            handleInputChange(
                              "yPosition",
                              e.target.value,
                              24 - settings.height
                            )
                          }
                          value={settings.yPosition || 0}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Text size</div>
                    <input
                      name="textsizedate"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.textSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "textSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto ">zIndex</div>
                    <input
                      name="textsizedate"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.zIndex || 0}
                      onChange={(e) =>
                        handleSettingChange("zIndex", parseInt(e.target.value))
                      }
                    />
                  </li>
                  <li className="list-group-item">
                    <div className="me-auto">Date Format</div>
                    <select
                      id={`dateselector${id}`}
                      className="form-select"
                      value={settings.dateFormat}
                      onChange={handleDateFormatChange}
                    >
                      <option value="dddd, MMMM Do YYYY">
                        dddd, MMMM Do YYYY
                      </option>
                      <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                      <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                      <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                      <option value="Do MMMM YYYY">Do MMMM YYYY</option>
                      <option value="MMMM Do, YYYY">MMMM Do, YYYY</option>
                    </select>
                  </li>
                </ol>
              </>
              <div className="accordion accordion-flush" id="accordionTopbar">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOneTopbar"
                      aria-expanded="true"
                      aria-controls="collapseOneTopbar"
                    >
                      Background Color
                    </button>
                  </h2>
                  <div
                    id="collapseOneTopbar"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionTopbar"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.backgroundColor}
                        onChangeComplete={handleOnBackgroundChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFourTopbar"
                      aria-expanded="true"
                      aria-controls="collapseFourTopbar"
                    >
                      Text Color
                    </button>
                  </h2>
                  <div
                    id="collapseFourTopbar"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionTopbar"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.textColor}
                        onChangeComplete={handleOnTextColorChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {deleteConfirmation ? (
                  <>
                    <div>Are you sure ?</div>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm rounded-0 "
                      onClick={deleteData}
                      data-bs-dismiss="modal"
                    >
                      YES
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm rounded-0"
                      onClick={() => setDeleteConfirmation(false)}
                    >
                      NO
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm rounded-0 "
                      onClick={() => setDeleteConfirmation(true)}
                    >
                      {" "}
                      REMOVE COMPONENT{" "}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm rounded-0"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
};
